module.exports = __webpack_public_path__ + "/images/cover-fr-heart-sale.bb2352f.png";